import { flexRender, getCoreRowModel, useReactTable } from '@tanstack/react-table';

// Import styles
import { StyledTable, TableContainer, StyledHeading, StyledData } from './styles';

// Import types
import type { SummaryProduct } from 'types/views/configurator';

// Import columns
import { columns } from './variables/columns';

type Props = {
	data?: SummaryProduct[];
	isPromotion: boolean;
};

export const PaymentTable = ({ data = [], isPromotion }: Props) => {
	const table = useReactTable({
		data,
		columns: columns(isPromotion),
		defaultColumn: { size: 250 },
		getCoreRowModel: getCoreRowModel(),
		state: {
			columnVisibility: {
				promo_days_period: isPromotion
			}
		}
	});

	return (
		<TableContainer>
			<StyledTable>
				<thead>
					{table.getHeaderGroups().map((headerGroup) => (
						<tr key={headerGroup.id}>
							{headerGroup.headers.map(({ id, column, getSize, getContext }) => (
								<StyledHeading key={id} width={getSize()}>
									{flexRender(column.columnDef.header, getContext())}
								</StyledHeading>
							))}
						</tr>
					))}
				</thead>
				<tbody>
					{table.getRowModel().rows.map(({ id, getVisibleCells }) => (
						<tr key={id}>
							{getVisibleCells().map(({ id, column, getContext }) => (
								<StyledData key={id}>{flexRender(column.columnDef.cell, getContext())}</StyledData>
							))}
						</tr>
					))}
				</tbody>
				<tfoot>
					{table.getFooterGroups().map(({ id, headers }) => (
						<tr key={id}>
							{headers.map(({ id, column, getContext }) => (
								<StyledHeading key={id} modifiers="footer">
									{flexRender(column.columnDef.footer, getContext())}
								</StyledHeading>
							))}
						</tr>
					))}
				</tfoot>
			</StyledTable>
		</TableContainer>
	);
};
